module.exports = __webpack_public_path__ + "img/chatting.a970e316.svg";